import React, { useEffect } from 'react';
import './Hero.css';

function AnimatedCounter({ target, decimals = 0, suffix = '' }) {
  useEffect(() => {
    const el = document.querySelector(`[data-counter="${target}"]`);
    if (!el || el.dataset.done) return;

    el.dataset.done = '1';
    const dur = 1800;
    const start = performance.now();
    const ease = (t) => 1 - Math.pow(1 - t, 3);

    const tick = (now) => {
      const t = Math.min(1, (now - start) / dur);
      const v = target * ease(t);
      el.textContent = v.toFixed(decimals);
      if (t < 1) requestAnimationFrame(tick);
      else el.textContent = target.toFixed(decimals);
    };

    requestAnimationFrame(tick);
  }, [target, decimals]);

  return null;
}

export default function Hero() {
  useEffect(() => {
    const els = document.querySelectorAll('.reveal, .reveal-rule');
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          setTimeout(() => e.target.classList.add('in'), i * 120);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach((el) => io.observe(el));

    return () => io.disconnect();
  }, []);

  useEffect(() => {
    const el = document.querySelector('.ticker span:last-child');
    if (!el) return;

    const fmt = () => {
      const d = new Date();
      const pad = (n) => String(n).padStart(2, '0');
      const day = pad(d.getUTCDate());
      const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      const m = months[d.getUTCMonth()];
      const y = d.getUTCFullYear();
      return `Live · ${day} ${m} ${y} · ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} GMT`;
    };

    el.textContent = fmt();
    const interval = setInterval(() => { el.textContent = fmt(); }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero shell" id="top">
      <div className="hero__top">
        <div className="hero__meta reveal">
          <span>Practice</span>
          <span>Software Engineering</span>
        </div>
        <div className="hero__meta reveal">
          <span>Specialism</span>
          <span>Software product & platforms</span>
        </div>
        <div className="hero__meta reveal">
          <span>Established</span>
          <span>Sydney · 2022</span>
        </div>
        <div className="hero__meta reveal">
          <span>Status</span>
          <span style={{ color: '#6FCF97' }}>Accepting engagements · Q3 2026</span>
        </div>
      </div>

      <div className="hero__head">
        <h1 className="display hero__title reveal">
          <span className="line">Engineered</span>
          <span className="line">software for</span>
          <span className="line"><em style={{ color: 'rgba(244, 241, 234, 0.4)' }}>ambitious</em></span>
          <span className="line">operators.</span>
        </h1>
      </div>

      <div className="hero__divider reveal" style={{ borderTop: '1px solid rgba(244, 241, 234, 0.15)', marginBottom: 'var(--spacing-2xl)', marginTop: 'var(--spacing-2xl)' }}></div>

      <div className="hero__content reveal">
        <p className="hero__lede">
          <strong>K Capital Technology</strong> is a Sydney-founded software studio that builds platforms across finance, web3, AI, social and SaaS — from regulated infrastructure to consumer products. We are software engineers, not consultants.
        </p>

        <div className="hero__sub">
          <div className="fact">
            <span className="fact__label">Engagements delivered</span>
            <span className="fact__value">
              <span data-counter="62">0</span>
            </span>
          </div>
          <div className="fact">
            <span className="fact__label">Transactional volume completed</span>
            <span className="fact__value">
              50+ Million
            </span>
          </div>
          <div className="fact">
            <span className="fact__label">Avg. engagement</span>
            <span className="fact__value">
              <span data-counter="18">0</span><sup>MO</sup>
            </span>
          </div>
          <div className="fact">
            <span className="fact__label">Client retention</span>
            <span className="fact__value">
              <span data-counter="94">0</span><sup>%</sup>
            </span>
          </div>
          <AnimatedCounter target={62} />
          <AnimatedCounter target={18} />
          <AnimatedCounter target={94} />
        </div>
      </div>

      <div className="ticker reveal">
        <span>↘ Scroll · K—CT / Homepage / v.04.26</span>
        <span>Sydney · Dubai</span>
        <span>Live · 01 May 2026 · 14:32 GMT</span>
      </div>
    </section>
  );
}
